import React from 'react';
import { exportToCSV, exportToXLSX, exportToPDF } from '../utils/exportData';

// Drop-in export controls for any grid. Pass rows + columns ([{key,label}]).
export default function ExportButtons({ rows, columns, filename = 'export', title = '' }) {
  const disabled = !rows || !rows.length;
  return (
    <div className="flex-gap" style={{ gap:6 }}>
      <button className="btn btn-secondary btn-sm" disabled={disabled} onClick={() => exportToXLSX(rows, columns, filename)}>⬇ Excel</button>
      <button className="btn btn-secondary btn-sm" disabled={disabled} onClick={() => exportToCSV(rows, columns, filename)}>⬇ CSV</button>
      <button className="btn btn-secondary btn-sm" disabled={disabled} onClick={() => exportToPDF(rows, columns, filename, title)}>⬇ PDF</button>
    </div>
  );
}
